import { render } from "./level3.vue?vue&type=template&id=5743c7e2"
import script from "./level3.vue?vue&type=script&lang=js"
export * from "./level3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__